export const CONTENT_STATUS = Object.freeze({
  PUBLISH: 1,
  PRE_PUBLISH: 2,
  UNPUBLISH: 3,
  COMING_SOON: 4,
});

export const isComingSoon = (status) =>
  Number(status) === CONTENT_STATUS.COMING_SOON;

export const isPublished = (status) =>
  Number(status) === CONTENT_STATUS.PUBLISH;

// Older episodes have no status and remain published by default.
export const isPublishedEpisode = (status) =>
  status === undefined || status === null
    ? true
    : isPublished(status);

export const canPlayEpisode = (content, episode) =>
  isPublished(content?.status) && isPublishedEpisode(episode?.status);
